import { JSX } from 'react';
import { Modal } from '@bg-components/Modal';
import { IModalProps, ModalName } from '@bg-shared';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { Profile } from '@bg-components/Profile';
import { PagesModalHeader } from '../components/PagesModalHeader';
import classes from './GamificationModal.module.scss';

export const GamificationModal = (props: IModalProps): JSX.Element => (
    <Modal
        className={classes.modal}
        modalName={ModalName.GAMIFICATION}
        animation={fadeAnimation}
        onClose={props.onClose}
    >
        <PagesModalHeader title="" onClose={props.onClose} />
        <ModalContent>
            <Profile />
        </ModalContent>
    </Modal>
);
